/** Match backend multer-filename.util — repair UTF-8 names mangled as latin1. */
export function repairUploadFileName(fileName: string | undefined | null, fallback = ''): string {
  if (!fileName?.trim()) {
    return fallback;
  }

  const trimmed = fileName.trim();
  if (!/[\u0080-\u00ff]/.test(trimmed)) {
    return trimmed;
  }

  try {
    const bytes = new Uint8Array(trimmed.length);
    for (let i = 0; i < trimmed.length; i += 1) {
      bytes[i] = trimmed.charCodeAt(i) & 0xff;
    }
    const decoded = new TextDecoder('utf-8', { fatal: false }).decode(bytes).trim();
    if (!decoded || decoded.includes('\uFFFD')) {
      return trimmed;
    }
    return decoded;
  } catch {
    return trimmed;
  }
}
